import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export abstract class HttpService {
  private readonly BASE_API_URL = '/v1/api';

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  private getToken(): string | null {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('token');
    }
    return null;
  }

  private getHeaders() {
    const token = this.getToken();
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    if (token) {
      headers = headers.append('Authorization', `jwt ${token}`);
    }

    return headers;
  }

  getSvg(path: string): Observable<string> {
    return this.http.get(path, { responseType: 'text' });
  }

  get<T>(url: string, params?: any): Observable<T> {
    return this.http.get<T>(`${this.BASE_API_URL}${url}`, {
      headers: this.getHeaders(),
      params,
    });
  }

  post<T>(url: string, body: any): Observable<T> {
    return this.http.post<T>(`${this.BASE_API_URL}${url}`, body, {
      headers: this.getHeaders(),
    });
  }

  patch<T>(url: string, body: any): Observable<T> {
    return this.http.patch<T>(`${this.BASE_API_URL}${url}`, body, {
      headers: this.getHeaders(),
    });
  }

  put<T>(url: string, body: any): Observable<T> {
    return this.http.put<T>(`${this.BASE_API_URL}${url}`, body, {
      headers: this.getHeaders(),
    });
  }

  delete<T>(url: string): Observable<T> {
    return this.http.delete<T>(`${this.BASE_API_URL}${url}`, {
      headers: this.getHeaders(),
    });
  }

  getWithRawUrl<T>(url: string): Observable<T> {
    return this.http.get<T>(url);
  }

  postWithAuthCheck<T>(url: string, body: any): Observable<T> {
    if (!this.getToken()) return of();

    return this.http.post<T>(`${this.BASE_API_URL}${url}`, body, {
      headers: this.getHeaders(),
    });
  }
}
